import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AdminService } from '../admin.service';
import { CookieService } from '../../cookie.service';

@Component({
  selector: 'app-admin-layout',
  standalone: false,
  templateUrl: './admin-layout.component.html',
  styleUrls: ['./admin-layout.component.css']
})
export class AdminLayoutComponent {

  constructor(
    private admin: AdminService,
    private cookie: CookieService,
    private router: Router
  ) { }

  logout(): void {
    // Revoke server-side, then clear the readable session cookies and return to
    // login regardless of the API result (fail-open on logout).
    this.admin.logout().subscribe({
      next: () => this.finishLogout(),
      error: () => this.finishLogout()
    });
  }

  private finishLogout(): void {
    this.cookie.deleteCookie('otd-token-temp');
    this.cookie.deleteCookie('otd-userName');
    this.cookie.deleteCookie('otd-user');
    this.router.navigate(['/']);
  }
}
